import { Component, Output, EventEmitter, OnInit, Input, ViewChild } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ModalComponent } from '../../../modal/modal.component';

@Component({
  selector: 'customer-form',
  templateUrl: './customer-form.component.html',
  standalone: false
})
export class CustomerFormComponent implements OnInit {
  @Input() public processing;
  @Input() public customer: any;
  @Input() public languages: any;
  @Input() public countries: any;
  @Input() public localEntities: any;
  @Output() public toggleCreateCustomer: EventEmitter<any> = new EventEmitter();
  @Output() public toggleCancel: EventEmitter<any> = new EventEmitter();

  public customerForm: UntypedFormGroup;

  ngOnInit(): void {
    this.initForm();
    if (this.customer) {
      this.customerForm.patchValue(this.customer);
    }
  }

  initForm(): void {
    this.customerForm = new UntypedFormGroup({
      clientNumber: new UntypedFormControl(null, Validators.required),
      name: new UntypedFormControl(null, Validators.required)
    });
  }

  public save() {
    if (this.customerForm.invalid) {
      return;
    }
    this.toggleCreateCustomer.emit(this.customerForm.value);
  }

  public cancel() {
    this.toggleCancel.emit();
  }
}
